import { render, staticRenderFns } from "./BbeeNoticiasND.vue?vue&type=template&id=a41ea9d2"
import script from "./BbeeNoticiasND.vue?vue&type=script&lang=js"
export * from "./BbeeNoticiasND.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports